var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"src":_vm.props.src,"data-src":_vm.props.dataSrc,"alt":_vm.props.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }